import type { IExtractParams } from "@/routes";
import { generatePath } from "@/routes/utils";

const pathBase = `/files/`;
const pathById = `${pathBase}:fileId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const files = {
  getAll: (param: IPathBaseParam) => generatePath(pathBase, param),
  post: (param: IPathBaseParam) => generatePath(pathBase, param),
  put: (param: IPathByIdParam) => generatePath(pathById, param),
  delete: (param: IPathByIdParam) => generatePath(pathById, param),
} as const;
